import { create } from 'zustand';
import type { BillingTier } from '../lib/billing';
import type { PlanGate, VerificationGate } from '../lib/planGates';

export interface PlanPickerRequest {
  /** The tier to highlight, e.g. the tier an upgrade dialog asked for. */
  highlightTier?: BillingTier | null;
  /** Why the picker opened, shown above the plans ("Webhooks need Pro"). */
  reason?: string | null;
}

interface PlanGateState {
  upgrade: PlanGate | null;
  verify: VerificationGate | null;
  planPicker: PlanPickerRequest | null;
  openUpgrade: (gate: PlanGate) => void;
  closeUpgrade: () => void;
  openVerify: (gate: VerificationGate) => void;
  closeVerify: () => void;
  openPlanPicker: (request?: PlanPickerRequest) => void;
  closePlanPicker: () => void;
}

/** One app-wide upgrade dialog, plan picker and verify-email gate, opened from anywhere. */
export const usePlanGateStore = create<PlanGateState>((set) => ({
  upgrade: null,
  verify: null,
  planPicker: null,
  openUpgrade: (gate) => set({ upgrade: gate }),
  closeUpgrade: () => set({ upgrade: null }),
  openVerify: (gate) => set({ verify: gate }),
  closeVerify: () => set({ verify: null }),
  openPlanPicker: (request = {}) => set({ planPicker: request, upgrade: null }),
  closePlanPicker: () => set({ planPicker: null }),
}));
